import { render, staticRenderFns } from "./SistemaUsuarioEdit.vue?vue&type=template&id=efb9a3aa"
import script from "./SistemaUsuarioEdit.vue?vue&type=script&lang=js"
export * from "./SistemaUsuarioEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports